import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoanType } from "../../types/loanType";

type loanState = {
  data: Array<LoanType>;
};

const initialState: loanState = {
  data: [],
};

export const loanSlice = createSlice({
  name: "loanState",
  initialState,
  reducers: {
    setLoanState: (state, action: PayloadAction<LoanType[]>) => {
      state.data = action.payload;
    },
  },
});

export const { setLoanState } = loanSlice.actions;

export default loanSlice.reducer;
